<template>
  <div class="p_cusdtl_content">
    <div class="topOperation">
      <div class="top-left">
          <div><ShowNavHead/></div>
          <div class="screenInputs">
                <!-- <div class="screenInput">
                  <div class="flname">查询内容</div>
                  <el-input v-model="listQuery.SurveyName" placeholder="" clearable @keyup.enter.native="searchHandle"></el-input>
                </div> -->
                <div class="screenInput w200">
                    <div class="flname">客户分类</div>
                    <el-select v-model="listQuery.BusiType" size="small" placeholder="">
                        <el-option label="闪查客户管理" :value="'1'" />
                        <el-option label="内部项目闪查管理" :value="'2'" />
                    </el-select>
                </div>
                <div class="screenInput w200" v-if="listQuery.BusiType == '1'">
                    <div class="flname">闪查客户</div>
                    <el-select v-model="listQuery.BusiId" size="small" placeholder="" clearable filterable>
                      <el-option
                        v-for="(item, index) in backList"
                        :key="index + 'b'"
                        :label="item.Name"
                        :value="item.Id"
                      ></el-option>
                    </el-select>
                </div>
                <div class="screenInput w200" v-if="listQuery.BusiType == '2'">
                    <div class="flname">内部项目</div>
                    <el-select v-model="listQuery.BusiId" size="small" placeholder="" clearable filterable>
                      <el-option
                        v-for="(item, index) in internalList"
                        :key="index + 'w'"
                        :label="item.StrCustShortName"
                        :value="item.Projectid"
                      ></el-option>
                    </el-select>
                </div>
                <div class="screenInput w100">
                    <div class="flname">交易类型</div>
                    <el-select v-model="listQuery.TradeType" style="margin-right:24px;" class="s_sel_top" filterable clearable size="small" placeholder="" @change="searchHandle">
                        <el-option label="充值" :value="'充值'" />
                        <el-option label="消费" :value="'消费'" />
                        <el-option label="调整" :value="'调整'" />
                    </el-select>
                    <el-button type="success" size="small" @click="searchHandle">搜索</el-button>
                </div>
          </div>
      </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>产品</el-breadcrumb-item>
              <el-breadcrumb-item>小杰闪查</el-breadcrumb-item>
              <el-breadcrumb-item>闪查管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p_cusDtl_table" v-if="checkPermission(['bgSet_customer_manage'],permissionLists)">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="闪查客户管理" name="third"></el-tab-pane>
                <el-tab-pane v-if="checkPermission(['bgSet_project_manage'],permissionLists)" label="内部项目闪查管理" name="second"></el-tab-pane>
                <el-tab-pane v-if="checkPermission(['bgSet_product_manage'],permissionLists)" label="闪查产品管理" name="first"></el-tab-pane>
                <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="客户消费明细" name="four"></el-tab-pane>
              <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="客户订单" name="five"></el-tab-pane>
              <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="申请试用列表" name="six"></el-tab-pane>
            </el-tabs>
            <div class="bgset_btn">
              <el-button :loading="exportLoading" type="success" size="small" v-if="!isNull(tableData)" @click="exportHandle">导出</el-button>
            </div>
             <!-- @selection-change="handleSelectionChange" -->
            <el-table ref="multipleTable" v-loading="loading" :data="tableData" style="width: 100%">
                <el-table-column prop="CreateTime" align="center" label="交易时间" fit show-overflow-tooltip min-width="160px">
                  <template slot-scope="{row}">
                    {{ row.CreateTime?row.CreateTime.replace('T',' '):'' }}
                  </template>
                </el-table-column>
                <el-table-column prop="InquiryAgency" align="center" label="客户机构" min-width="200px" fit show-overflow-tooltip />
                <el-table-column prop="SerialNumber" align="center" label="流水号" min-width="180px" fit show-overflow-tooltip />
                <el-table-column prop="TradeType" align="center" label="交易类型" min-width="80px" fit show-overflow-tooltip />
                <el-table-column prop="Amount" align="center" label="金额" min-width="100px" fit show-overflow-tooltip />
                <el-table-column prop="Balance" align="center" label="余额" min-width="100px" fit show-overflow-tooltip />
                <el-table-column prop="Remark" align="center" label="备注" min-width="200px" fit show-overflow-tooltip />
            </el-table>
            <div v-if="totalCount>0" class="block">
                <el-pagination :current-page.sync="listQuery.pageNum" :page-size="listQuery.pageSize" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount" @current-change="changeBPage" @size-change="handleSizeChange" />
            </div>
      </div>
    </div>
  </div>
</template>

<script>
import xz from "@/common";
import checkPermission from '@/utils/permission' // 权限判断函数
import {downloadPDF} from "@/utils/pdf.js";
export default {
  name: "serviceCenter",
  data() {
    return {
        showDropScreen: -1,
        totalCount: 0,
        listQuery: {
          TradeType: '',//充值 消费 调整
          BusiType:'1',//2代表时项目的，1代表是客户
          BusiId: '',
          IsExport:'',// 1 导出 列表传空
          pageNum: 1,
          pageSize: 10
        },
        exportQuery:{},
        resProjectList: [],
        InquiryAgency: '', // 公司名称
        pickerOptions: {
          shortcuts: [{
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        },
        tableData: [],
        loading: false,
        result: {},
        hasResult: false,
        expvivw: false,
        multipleTable: [],
        interval: '', // 定时器
        expLoading: false,
        // 按钮权限参数
        butQuery: {
          path: '/bgSet',
          powerEnName: 'product'
        },
        permissionLists:[],
        activeName:'four',
        exportLoading:false,
        backList:[],
        internalList:[]
    }
  },
  created() {
      this.getButtonPower()
      this.getBackData("internal")
      this.getBackData("back")
  },
  methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let actives = this.$route.query.activeName;
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              if(!that.isNull(actives)){
                that.activeName = actives
                if(that.activeName == "second"){
                  that.$router.push({
                    path: '/bgSet',
                    query: {activeName:'second'}
                  })
                }else if(that.activeName == "first"){
                  that.$router.push({
                    path: '/bgSet',
                    query: {activeName:'first'}
                  })
                }else if(that.activeName == "third"){
                  that.$router.push({
                    path: '/bgSet',
                    query: {activeName:'third'}
                  })
                }else if(that.activeName == "four"){
                  that.getcertorderlist()
                }else if(that.activeName == "five"){
                  that.$router.push({
                    path: '/allCustomManage',
                    query: {activeName:'five'}
                  })
                }
              }else{
                if (that.checkPermission(['bgSet_customer_manage'], that.permissionLists)) {
                  that.activeName = 'four'
                  that.getcertorderlist()
                } else if ((!that.checkPermission(['bgSet_customer_manage'], that.permissionLists)) && (that.checkPermission(['bgSet_project_manage'], that.permissionLists))) {
                  that.$router.push({
                    path: '/bgSet',
                    query: {activeName:'second'}
                  })
                } else if ((!that.checkPermission(['bgSet_customer_manage'], that.permissionLists)) && (!that.checkPermission(['bgSet_project_manage'], that.permissionLists)) && (that.checkPermission(['bgSet_product_manage'], that.permissionLists))) {
                  that.$router.push({
                    path: '/bgSet',
                    query: {activeName:'first'}
                  })
                }
              }
            } else {
              this.permissionLists = []
              this.activeName = ''
            }
          } else {
            this.permissionLists = []
            this.activeName = ''
          }
        })
      },
      // 导出
      exportHandle(){
        this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
        this.exportQuery.pageSize = 1000000
        this.exportQuery.pageNum = 1
        this.exportQuery.IsExport = '1'
        this.exportLoading = true
        xz.getexpenselist(this.exportQuery).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = '消费明细' + '.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
          } else {
            this.$message({
              message: "导出失败，请稍后再试",
              type: "error"
            })
          }
          this.exportLoading = false
        })
      },
    // 筛选下拉
    dropDownScreen() {
        if (this.showDropScreen == -1) {
            this.showDropScreen = 1
        } else if (this.showDropScreen == 1) {
            this.showDropScreen = -1
        }
    },
    // 关闭筛选
    closeSearchHandle(){
      this.showDropScreen = -1
    },
      // 搜索
      searchHandle() {
        this.showDropScreen = -1
        this.listQuery.pageNum = 1
        this.getcertorderlist()
      },
      // 清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery
        this.listQuery.BusiType = '1'
      },
      //获取闪查产品管理列表
      getBackData(type) {
        let query = {
          pageNum: 1,
          pageSize: 100000000,
          name: ""
        }
        if (type == "internal") {
          xz.getprojectlist(query).then((res) => {
            if (res.status == "ok") {
              this.internalList = res.data.list;
            } else {
              this.internalList = [];
            }
          });
        } else if (type == "back") {
          xz.getcustomer(query).then((res) => {
            if (res.status == "ok") {
              this.backList = res.data.RetList;
            } else {
              this.backList = [];
            }
          });
        }
      },
      // 批量查询表格多选
      handleSelectionChange(val) {
        // console.log('yyy', val)
        this.multipleTable = val
      },
      getcertorderlist() {
        this.loading = true
        xz.getexpenselist(this.listQuery).then((res) => {
          // console.log(res)
          if (res.status == 'ok') {
            this.tableData = res.data.list
            this.totalCount = res.data.totalCount
          } else {
            this.tableData = []
            this.totalCount = 0
          }
        })
        this.loading = false
      },
      // 翻页
      changeBPage(val) {
        this.listQuery.pageNum = Number(val)
        this.getcertorderlist()
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
        this.listQuery.pageNum = 1
        this.listQuery.pageSize = Number(val)
        this.getcertorderlist()
      },
      isNull(o) {
        return (
          o == undefined ||
          o == 'undefined' ||
          (o + '').indexOf('undefined') > -1 ||
          o == null ||
          o == '' ||
          o == 'null' ||
          o == [] ||
          o == 'NaN' ||
          o == '[{}]'
        )
      },
      handleClick(tab, event) {
        // console.log(tab, event);
        let that = this
        this.activeName = tab.name;
        if (tab.name == "second") {
          that.$router.push({
            path: '/bgSet',
            query: {activeName:'second'}
          })
        } else if (tab.name == "first") {
          that.$router.push({
            path: '/bgSet',
            query: {activeName:'first'}
          })
        } else if (tab.name == "third") {
          that.$router.push({
            path: '/bgSet',
            query: {activeName:'third'}
          })
        } else if (tab.name == "four") {
          that.getcertorderlist()
        } else if (tab.name == "five") {
          that.$router.push({
            path: '/allCustomManage',
            query: {activeName:'five'}
          })
        }else if (tab.name == "six") {
          that.$router.push({
            path: '/bgSet',
            query: {activeName:'six'}
          })
        }
      }
  }
};
</script>
<style scoped>
.lh20{
  line-height: 20px;
  margin: 0;
}
#logo{
  display: none;
  width: 175px;
  height: 57px;
}
.bg_des_box{
  display: flex;
  align-items: center;
  border: 1px solid #dfe6ec;
  border-bottom:none;
  font-size: 14px;
  color:#333;
  background-color: rgb(221, 221, 221,.7);
}
.bg_des_left{
  width: 180px;
  text-align: left;
  padding: 10px 0;
  /* // color:#606266; */
  box-sizing: border-box;
}
.bg_des_right{
  flex: 1;
  text-align: left;
  padding: 10px;
  line-height: 20px;
  box-sizing: border-box;
  border-left: 1px solid #ddd;
}
.pic_txt{
  margin: 0;
  line-height: 20px;
}
.bg_result_box{
  width: 1001px;
}
.bg_result_box.bg_result_box00{
  width: auto;
}
.bg_result_box00 .bg_result_item{
  width: 100%;
  box-sizing: border-box;
}
.bg_result_item{
  color: #606266;
  background-color: #FFFFFF;
  font-size: 14px;
  border-collapse: collapse;
  display: table;
}
.bg_result_left{
  font-weight: 500;
  color: #000;
  width: 181px;
  text-align: left;
}
.bg_result_right{
  width: 820px;
  text-align: left;
}
.bg_result_cell{
  display: table-cell;
  border: 1px solid #e6ebf5;
  padding: 10px;
  box-sizing: border-box;
  border-collapse: collapse;
  line-height: 1.5;
}
.bg_result_item02 .bg_result_cell{
  border-top: none;
}

.category_title{
  width: 1001px;
  color: #606266;
  text-align: left;
  padding-left: 10px;
  background: rgb(25, 189, 146,.4);
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  box-sizing: border-box;
}
.category_title00.category_title{
  width: auto;
}
.bg_widthauto.bg_result_right{
  width: calc(100% - 181px);
}
.mb24{
  margin-bottom: 24px;
}
.w1000{
  width: 1000px;
}
.w1000_des{
  width: 1000px;
  padding: 15px 15px 0px 15px;
}
.c_border{
  border: 1px solid #dfe6ec;
  padding: 12px 10px;
}
.note_danger_txt{
  color: #000000a6;
  font-size: 14px;
}
.res_icon_right{
  font-size: 24px;
  color:#19bd92;
}
.res_icon_error{
  font-size: 24px;
  color:#F56C6C;
}
.title_note_box{
  color:#666;
  font-size: 14px;
  margin-bottom: 8px;
}
  .result_report_box {
    width: 100%;
    background: #fff;
    opacity: 0;
  }

  .result_report {
    width: 1201px;
    padding: 10px 100px 30px;
    margin: 0 auto;
    position: relative;
  }

  .logo img {
    width: 175px;
    margin-top: 20px;
  }

  .resultTitle {
    height: 36px;
    line-height: 36px;
    font-size: 15px;
    font-weight: 600;
    margin: 24px 0;
    width: 1000px;
  }

  .tableTitle {
    width: 1001px;
    color: #fff;
    background: #19bd92;
    text-align: center;
    height: 43px;
    line-height: 43px;
    font-size: 16px;
  }
.tips p {
    font-size: 13px;
    line-height: 20px;
  }
  .block {
    background-color: #fff;
    text-align: right;
    padding: 10px 10px 10px;
  }

  .flname {
    min-width: 40px;
    width: 66px;
    padding-right: 8px;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .proName {
    font-weight: 700;
    font-size: 14px;
    margin-left: 15px;
  }

  .page_backgroundCheckRecord {
    min-height: calc(100vh - 84px);
    background: #f3f3f3;
    /* padding: 12px 16px; */
  }

  .topOperation {
    height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    width: 100%;
    background-color: #ffffff;
  }

  .top-left {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    margin-top: 10px;
  }

  .screenInputs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    /* flex-wrap: wrap; */
  }

  .screenInput {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 0 10px 15px;
    font-size: 14px;
    color: #606266;
  }

  .flname {
    min-width: 40px;
    width: 68px;
    padding-right: 8px;
    font-size: 14px;
    text-align: right;
  }

  .drop-footer {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    padding: 0 30px 20px 0;
  }

  .rpTirle {
    font-size: 48px;
    text-align: center;
    width: 100%;
    font-weight: bold;
  }

  .rpContent {
    text-align: center;
    width: 100%;
    margin: 24px 0;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dot {
    border-radius: 100%;
    background: #19bd92;
  }

  .dot1 {
    width: 8px;
    height: 8px;
  }

  .dot2 {
    width: 12px;
    height: 12px;
    margin: 0 8px;
  }

  .dot3 {
    width: 16px;
    height: 16px;
  }

  .statement {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 18px;
  }

  .statementContent {
    text-indent: 2em;
    line-height: 32px;
    font-size: 16px;
  }

  .cover {
    height: 1730px;
    width: 1000px;
    position: relative;
    background: #fff;
  }

  .coverLeft {
    position: absolute;
    left: 0;
    top: 0;
  }

  .coverRight {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 674px;
  }
.top-right{
  margin-right: 20px;
}
.bgset_btn{
  display:flex;
  justify-content: flex-end;
  padding: 0 16px;
}
.p_cusDtl_table{
  background-color: #fff;
}
</style>
<style>
.p_cusdtl_content .screenInput{
  margin-left: 3px;
}
.p_cusdtl_content .screenInput.w200 .el-input{
  width: 180px;
}
.p_cusdtl_content .screenInput.w100 .el-input{
  width: 100px;
}
.p_cusDtl_table{
  background-color: #fff;
}
.p_cusDtl_table .el-tabs{
    background: #fff;
    padding: 10px 16px 3px;
  }
  .re_down_form1 .el-form-item {
    margin-bottom: 10px;
  }

  .page_backgroundCheckRecord .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 230px !important;
    height: 32px;
    line-height: 32px;
  }

  .checktime .el-date-editor .el-range__icon {
    height: 32px !important;
  }

  .personalAdvanced .el-descriptions-item__label.is-bordered-label {
    color: #000;
    width: 180px;
    line-height: 20px !important;
  }

  .personalAdvanced .el-descriptions-item__content {
    width: 320px !important;
    line-height: 20px !important;
  }

.page_backgroundCheckRecord .el-input__icon{
  height: 32px;
}
</style>